import { render, staticRenderFns } from "./PopupSearchPet.vue?vue&type=template&id=2bbb61fb&scoped=true&"
import script from "./PopupSearchPet.vue?vue&type=script&lang=js&"
export * from "./PopupSearchPet.vue?vue&type=script&lang=js&"
import style0 from "./PopupSearchPet.vue?vue&type=style&index=0&id=2bbb61fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb61fb",
  null
  
)

export default component.exports